import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import { setRef } from '@beef/react/utils';
import { findClosestFiberNodeMatching, findDOMParent, getFiberNodeFromDOM } from "../internals";
/**
 * Компонент использует react internal api и MutationObserver
 *   для хранения актуальных прямых потомков виртуального компонента
 *
 * TODO-1: Уникальный кейс - порталы, для них логика прослушивания DOM-родителя ломается
 * TODO-2: Отключение mutation-observer'а - принять решение каким образом и реализовать
 */
export var ChildrenMutationObserver = /*#__PURE__*/function (_React$Component) {
  _inherits(ChildrenMutationObserver, _React$Component);
  var _super = _createSuper(ChildrenMutationObserver);
  function ChildrenMutationObserver() {
    var _this;
    _classCallCheck(this, ChildrenMutationObserver);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    // eslint-disable-next-line react/sort-comp
    _defineProperty(_assertThisInitialized(_this), "parentObserver", void 0);
    _defineProperty(_assertThisInitialized(_this), "isDescendantElement", function (el) {
      return !!findClosestFiberNodeMatching(getFiberNodeFromDOM(el), function (fiber) {
        return fiber.stateNode === _assertThisInitialized(_this);
      });
    });
    return _this;
  }
  _createClass(ChildrenMutationObserver, [{
    key: "updateChildren",
    value: function updateChildren() {
      var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      setRef(elements.filter(this.isDescendantElement), this.props.elementsRef);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var parentNode = findDOMParent(this);
      this.parentObserver = new MutationObserver(function () {
        _this2.updateChildren(Array.from(parentNode.children));
      });
      this.updateChildren(Array.from(parentNode.children));
      this.parentObserver.observe(parentNode, {
        childList: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children || null;
    }
  }]);
  return ChildrenMutationObserver;
}(React.Component);